import { Plan } from '../components/Plan';

const PlanPage = () => {
  return (
    <div className="flex-col bg-transparent">
      <Plan />
    </div>
  );
};

export default PlanPage;
